module.exports = __webpack_public_path__ + "static/media/logo_virbac.ecf77321.svg";